import {Separator} from 'platform/components';
import {VStack} from 'platform/foundation';

import {useCallback} from 'react';

import {mergeAll} from 'ramda';

import {DmsDataGrid, WAREHOUSE_GRID_CODES} from '@dms/shared';
import {useWarehouseParams} from '@dms/warehouse/shared-components';

import {RequiredTestIdProps} from 'shared/web';

import type {QueryFilterObject} from 'features/eag-grid';

interface FullyReturnedItemsSegmentProps extends RequiredTestIdProps {}

export function FullyReturnedItemsSegment(props: FullyReturnedItemsSegmentProps) {
  const {directSaleId} = useWarehouseParams();

  const queryModifier = useCallback(
    (filter: QueryFilterObject) => mergeAll([filter, {directSaleId}]),
    [directSaleId]
  );

  return (
    <VStack height="100%" data-testid={props['data-testid']}>
      <Separator />
      <DmsDataGrid
        gridCode={WAREHOUSE_GRID_CODES.directSaleFullyReturnedItems}
        data-testid={WAREHOUSE_GRID_CODES.directSaleFullyReturnedItems}
        queryModifier={queryModifier}
        autoHeight
      />
    </VStack>
  );
}
